export default __webpack_public_path__ + "static/media/IMG_5336.3d093ee3.JPG";